export default __webpack_public_path__ + "static/media/PhysicalDescriptions_02.fbcfc101.png";